<template>
  <div class="min-h-screen bg-stone-100 flex">
    <div class="flex-1 flex flex-col py-12 px-4 sm:px-6 justify-center sm:px-6 lg:flex-none lg:px-20 xl:px-24">
      <div class="mx-auto w-full max-w-sm">
        <div class="text-center">
          <img class="max-h-14 w-auto mx-auto" src="/images/logo-bp-noclaim.png" alt="Brainspro">
          <h1 class=" text-3xl leading-9 font-extrabold text-gray-700">
            {{ $t("login.log_account") }}
          </h1>
          <p class="mt-2 text-sm leading-5 text-gray-600 max-w ">
            O
            <a href="/signup" class="font-medium text-blue-600 hover:text-blue-500 focus:outline-none focus:underline transition ease-in-out duration-150">
              {{ $t('login.create_account') }}
            </a>
          </p>
        </div>

        <div class="mt-8">
          <div>
            <div class="hidden">
              <p class="text-sm leading-5 font-medium text-gray-700">
                {{ $t('login.log_with') }}
              </p>

              <div class="mt-1 grid grid-cols-3 gap-3">
                <div>
                <span class="w-full inline-flex rounded-md shadow-sm">
                  <button type="button"
                          class="w-full inline-flex justify-center py-2 px-4 border border-gray-300 rounded-md bg-white text-sm leading-5 font-medium text-gray-500 hover:text-gray-400 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition duration-150 ease-in-out"
                          aria-label="Sign in with Facebook">
                    <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                      <path fill-rule="evenodd"
                            d="M20 10c0-5.523-4.477-10-10-10S0 4.477 0 10c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V10h2.54V7.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V10h2.773l-.443 2.89h-2.33v6.988C16.343 19.128 20 14.991 20 10z"
                            clip-rule="evenodd"/>
                    </svg>
                  </button>
                </span>
                </div>

                <div>
                <span class="w-full inline-flex rounded-md shadow-sm">
                  <button type="button"
                          class="w-full inline-flex justify-center py-2 px-4 border border-gray-300 rounded-md bg-white text-sm leading-5 font-medium text-gray-500 hover:text-gray-400 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition duration-150 ease-in-out"
                          aria-label="Sign in with Twitter">
                    <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                      <path
                          d="M6.29 18.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0020 3.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.073 4.073 0 01.8 7.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 010 16.407a11.616 11.616 0 006.29 1.84"/>
                    </svg>
                  </button>
                </span>
                </div>

                <div>
                <span class="w-full inline-flex rounded-md shadow-sm">
                  <button type="button"
                          class="w-full inline-flex justify-center py-2 px-4 border border-gray-300 rounded-md bg-white text-sm leading-5 font-medium text-gray-500 hover:text-gray-400 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition duration-150 ease-in-out"
                          aria-label="Sign in with GitHub">
                    <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                      <path fill-rule="evenodd"
                            d="M10 0C4.477 0 0 4.484 0 10.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0110 4.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.203 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.942.359.31.678.921.678 1.856 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0020 10.017C20 4.484 15.522 0 10 0z"
                            clip-rule="evenodd"/>
                    </svg>
                  </button>
                </span>
                </div>
              </div>
            </div>

            <div class="mt-6 relative hidden">
              <div class="absolute inset-0 flex items-center">
                <div class="w-full border-t border-gray-300"></div>
              </div>
              <div class="relative flex justify-center text-sm leading-5">
                                <span class="px-2 bg-white text-gray-500">
                                  {{ $t('login.continue_with') }}
                                </span>
              </div>
            </div>
          </div>

          <div class="hidden rounded-md bg-yellow-50 p-4">
            <div class="flex">
              <div class="flex-shrink-0">
                <!-- Heroicon name: solid/exclamation -->
                <svg class="h-5 w-5 text-yellow-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                     fill="currentColor" aria-hidden="true">
                  <path fill-rule="evenodd"
                        d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                        clip-rule="evenodd"/>
                </svg>
              </div>
              <div class="ml-3">
                <h3 class="text-sm font-medium text-yellow-800">
                  {{ $t('login.attention') }}
                </h3>
                <div class="mt-2 text-sm text-yellow-700">
                  <p>
                    {{ $t('login.welcome_text1') }} <br><b>{{ $t('login.admin_access') }}</b>.
                    {{ $t('login.welcome_text2') }}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="mt-6">
            <form action="#" method="POST" @submit.prevent="login">
              <div>
                <label for="email" class="block text-sm font-medium leading-5 text-gray-700">
                  {{ $t('general.email_address') }}
                </label>
                <div class="mt-1 rounded-md shadow-sm">
                  <input id="email" type="email" v-model="request.email" required
                         class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5">
                </div>
              </div>

              <div class="mt-6">
                <label for="password" class="block text-sm font-medium leading-5 text-gray-700">
                  {{ $t('general.pass') }}
                </label>
                <div class="mt-1 relative rounded-md shadow-sm">
                  <input v-bind:type="viewPassType" id="password" v-model="request.password" required
                         class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5">
                  <!-- Icono para mostrar contraseña o no -->
                  <div @click="clickOnEye" class="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400">
                    <!-- Heroicon name: solid/question-mark-circle -->
                    <svg v-if="!viewPass" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none"
                         viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"/>
                    </svg>
                  </div>
                  <div @click="clickOnEye" class="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400">
                    <svg v-if="viewPass" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none"
                         viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/>
                    </svg>
                  </div>
                  <!-- fin de icono ojo -->
                </div>
              </div>
              <div class="mt-6 flex items-center justify-between">
                <div class="flex items-center">
                  <input id="remember_me" type="checkbox" v-model="request.remember"
                         class="form-checkbox h-4 w-4 text-blue-600 transition duration-150 ease-in-out">
                  <label for="remember_me" class="ml-1.5 block text-sm leading-5 text-gray-900">
                    {{ $t('login.remember_me') }}
                  </label>
                </div>
                  <div class="text-sm leading-5 ml-1">
                    <a href="/remember-password"
                       class="font-medium text-blue-600 hover:text-blue-500 focus:outline-none focus:underline transition ease-in-out duration-150">{{ $t('login.forgot_pass') }}</a>
                  </div>
              </div>

              <div class="mt-6">
              <span class="block w-full rounded-md shadow-sm">
                <button type="submit"
                        class="w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-bpblue hover:bg-bpbluedeep focus:outline-none focus:border-blue-700 focus:shadow-outline-blue active:bg-bpbluedeep transition duration-150 ease-in-out">
                  {{ $t('login.access') }}
                </button>
              </span>
              </div>
            </form>
          </div>
          <div class="p-4 flex flex-col justify-center items-center ">
            <div class="flex text-xs text-gray-700">
              <span class="font-light">Con la tecnología de </span>
              <img class="max-h-7 w-auto mx-auto ml-1 -mt-1" src="/images/logo-bp-noclaim.png" alt="Brainspro">
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="hidden lg:block w-full h-100 overflow-hidden">
      <img class="object-center object-cover w-full h-full" src="/images/banners/banner_login_signup.jpeg"/>
    </div>
  </div>
</template>

<script>
import {useAuthUserStore} from "@/stores/auth";
import NotificationService from "@/services/notification/NotificationService";

export default {
  name: "LoginComponent",
  setup(){
    const authUserStore = useAuthUserStore();

    return {authUserStore}
  },
  data() {
    return {
      request: {
        email: '',
        password: '',
        remember: false
      },
      viewPass: false,
    }
  },
  computed: {
    viewPassType() {
      return (this.viewPass) ? 'text' : 'password'
    }
  },
  methods: {
    login() {

      //TODO PINIA AUTH
      this.authUserStore.login(this.request)
          .then(() => {
            console.log("Redireccionando al dashboard...")
            this.$router.push({name: 'dashboard'})
          })
          .catch((error) => {
            console.log("Ha fallado la autenticación...", error.response.data)
            if (error.response.data.message) {
              NotificationService.showNotification(error.response.data.message, "error")
            } else {
              NotificationService.showNotification("Upss! Parece que ha ocurrido un error, si pasados unos minutos el problema persiste. Ponte en contacto con el equipo se soporte", "error")
            }
          })
    },
    clickOnEye() {
      this.viewPass = !this.viewPass
    },
  }

}
</script>

<style scoped>

</style>